<template>
  <div>
    <nav
      class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl"
      id="navbarBlur"
      navbar-scroll="true"
    >
      <div class="container-fluid py-1 px-3">
        <nav aria-label="breadcrumb">
          <ol
            class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5"
          >
          <li
              class="nav-item d-xl-none ps-0 ms-0 me-3 d-flex align-items-center"
            >
              <button
                class="navbar-toggler shadow-none ms-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navigation"
                aria-controls="navigation"
                aria-expanded="false"
                ref="navbar"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon mt-2">
                  <span class="navbar-toggler-bar bar1"></span>
                  <span class="navbar-toggler-bar bar2"></span>
                  <span class="navbar-toggler-bar bar3"></span>
                </span>
              </button>
            </li>
            <!-- <li class="breadcrumb-item text-sm d-flex align-items-center d-none d-md-block d-lg-block">
              <a class="opacity-5 text-dark" href="javascript:;" @click="goToRoute('/admin/overview')">Inicio</a>
            </li> -->
          </ol>
        </nav>
        <div
          class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4"
          id="navbar"
        >
          <div class="ms-md-auto pe-md-3 d-flex align-items-center">
            
          </div>
          <ul class="navbar-nav justify-content-end">
            <li class="nav-item d-flex align-items-center justify-content-end">
              <img v-if="user.url_image"  :src="user.url_image" class="rounded-circle shadow-4-strong avatar-sm me-0 mb-0 img-fluid d-none d-md-block d-lg-block" alt="xd" style="height: 60px !important; width: 60px !important;" />
              <img v-else src="../../public/favicon/fvf_logo_icon.png" class="rounded-circle shadow-4-strong avatar-sm me-3 mb-0 img-fluid d-none d-md-block d-lg-block" alt="xd" style="height: 60px !important; width: 60px !important;" />
            </li>
            <div class="nav-item d-flex align-items-center justify-content-end me-4" style="max-width: 300px;">
              <div class="row">
                <b v-if="name" class="ms-0 ps-0 me-2 d-none d-md-block d-lg-block text-center" style="text-transform: capitalize !important; color:black !important;"><strong>{{name}}</strong></b>
                <b v-else class="ms-0 me-2 ps-0 d-none d-md-block d-lg-block text-center" style="text-transform: capitalize !important; color:black !important"><strong>No especificado</strong></b>

                <b v-if="user.type_user"  class="ms-0 me-2 ps-0 d-none d-md-block d-lg-block text-center" style="text-transform: none; font-size: small;">{{ user.type_user.name }}</b>
                <b v-else  class="ms-0 me-2 ps-0 d-none d-md-block d-lg-block text-center" style="text-transform: none; font-size: small;">Usuario</b>
              </div>
            </div>
            <li class="nav-item d-flex align-items-center">
              <!-- <a
                href="javascript:;"
                class="nav-link ms-2 text-body font-weight-bold px-0" style="text-transform: none !important"
              >
                <i class="fa fa-user me-sm-1"></i>
                <span class="d-sm-inline" style="color: rgb(53, 16, 32)" @click="closeSession"
                  > Cerrar sesión</span
                >
              </a> -->
              <a @click="closeSession" class="btn bg-gradient-fvf mt-3 w-100"
               style="cursor:pointer; color: rgb(255, 255, 255);">Cerrar sesión</a>
            </li>
            <!-- <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
              <a
                href="javascript:;"
                class="nav-link text-body p-0"
                id="iconNavbarSidenav"
              >
                <div class="sidenav-toggler-inner">
                  <i class="sidenav-toggler-line"></i>
                  <i class="sidenav-toggler-line"></i>
                  <i class="sidenav-toggler-line"></i>
                </div>
              </a>
            </li> -->
          </ul>
        </div>
      </div>
    </nav>
    <div class="collapse navbar-collapse ms-3 mobilemenu" id="navigation">
      <ul class="navbar-nav mt-3">
        <li class="nav-item" @click="goToRoute('/overview')">
          <a class="nav-link" :class="{ 'active': $route.path === '/overview'}" style="cursor:pointer; border-radius: 5%/50%; height: 30px;">
            <v-icon v-if="$route.path === '/overview'" fill="white" name="home"></v-icon>
            <v-icon v-else fill="#CCCCCC" name="home"></v-icon>
            <span class="nav-link-text ms-3" style="text-transform: none;">Inicio</span>
          </a>
        </li>
        <!-- <li class="nav-item mt-2" @click="goToRoute('/clubs/evaluationsclubs')">
          <a class="nav-link" :class="{ 'active': $route.path === '/clubs/evaluationsclubs' ? 'active': $route.path === '/clubs/evaluationsclubs' ? 'active': $route.path.includes('/clubs/evaluationsclubs/edit')}" style="cursor:pointer; border-radius: 5%/50%; height: 30px;">
            <v-icon v-if="$route.path === '/clubs/evaluationsclubs'" fill="white" name="futbol"></v-icon>
            <v-icon v-else fill="#CCCCCC" name="futbol"></v-icon>
            <span class="nav-link-text ms-3" style="text-transform: none;">Evaluaciones</span>
          </a>
        </li> -->
        <li class="nav-item mt-2" @click="goToRoute('/clubs/info')">
          <a class="nav-link" :class="{ 'active': $route.path === '/clubs/info' ? 'active': $route.path === '/clubs/info/new' ? 'active': $route.path.includes('/clubs/info/edit/') }" style="cursor:pointer; border-radius: 5%/50%; height: 30px;">
            <v-icon v-if="$route.path === '/clubs/info'" fill="white" name="users"></v-icon>
            <v-icon v-else fill="#CCCCCC" name="user"></v-icon>

            <span class="nav-link-text ms-3" style="text-transform: none;">Información inicial</span>
          </a>
        </li>
        <li class="nav-item mt-2" @click="goToRoute('/clubs/info_register')">
          <a class="nav-link" :class="{ 'active': $route.path === '/clubs/info_register'? 'active': $route.path === '/clubs/info_register/new' ? 'active': $route.path.includes('/clubs/info_register/edit/') }" style="cursor:pointer; border-radius: 5%/50%; height: 30px;">
            <v-icon v-if="$route.path === '/clubs/info_register'" fill="white" name="eye"></v-icon>
            <v-icon v-else fill="#CCCCCC" name="eye"></v-icon>

            <span class="nav-link-text ms-3" style="text-transform: none;">Registro de información</span>
          </a>
        </li>
        <!-- <li class="nav-item mt-2" @click="goToRoute('/admin/criterias')">
          <a class="nav-link" :class="{ 'active': $route.path === '/admin/criterias' ? 'active': $route.path === '/admin/criterias/new' ? 'active': $route.path.includes('/admin/criterias/edit/') }" style="cursor:pointer; border-radius: 5%/50%; height: 30px;">
            <v-icon v-if="$route.path === '/admin/criterias'" fill="white" name="file-alt"></v-icon>
            <v-icon v-else fill="#CCCCCC" name="file-alt"></v-icon>

            <span class="nav-link-text ms-3" style="text-transform: none;">Criterios</span>
          </a>
        </li>
        <li class="nav-item mt-2" @click="goToRoute('/admin/audits')">
          <a class="nav-link" :class="{ 'active': $route.path === '/admin/audits' }" style="cursor:pointer; border-radius: 5%/50%; height: 30px;">
            <v-icon v-if="$route.path === '/admin/audits'" fill="white" name="search"></v-icon>
            <v-icon v-else fill="#CCCCCC" name="search"></v-icon>

            <span class="nav-link-text ms-3" style="text-transform: none;">Auditorias</span>
          </a>
        </li>
        <li class="nav-item mt-2" @click="goToRoute('/admin/configs')">
          <a class="nav-link" :class="{ 'active': $route.path === '/admin/configs' ? 'active': $route.path === '/admin/period' ? 'active': $route.path === '/admin/period/new' ? 'active': $route.path.includes('/admin/period/edit/') ? 'active': $route.path === '/admin/typestatus' ? 'active': $route.path === '/admin/typestatus/new' ? 'active': $route.path.includes('/admin/typestatus/edit/') ? 'active': $route.path === '/admin/typeclub' ? 'active': $route.path === '/admin/typeclub/new' ? 'active': $route.path.includes('/admin/typeclub/edit/') ? 'active': $route.path === '/admin/leagues' ? 'active': $route.path === '/admin/leagues/new' ? 'active': $route.path.includes('/admin/leagues/edit/') ? 'active': $route.path === '/admin/typejuridic' ? 'active': $route.path === '/admin/typejuridic/new' ? 'active': $route.path.includes('/admin/typejuridic/edit/') ? 'active': $route.path === '/admin/licenses' ? 'active': $route.path === '/admin/licenses/new' ? 'active': $route.path.includes('/admin/licenses/edit/') ? 'active': $route.path === '/admin/typecriteria' ? 'active': $route.path === '/admin/typecriteria/new' ? 'active': $route.path.includes('/admin/typecriteria/edit/') ? 'active': $route.path === '/admin/areas' ? 'active': $route.path === '/admin/areas/new' ? 'active': $route.path.includes('/admin/areas/edit/')}" style="cursor:pointer; border-radius: 5%/50%; height: 30px;">
            <v-icon v-if="$route.path === '/admin/configs'" fill="white" name="tools"></v-icon>
            <v-icon v-else fill="#CCCCCC" name="tools"></v-icon>

            <span class="nav-link-text ms-3" style="text-transform: none;">Configuración</span>
          </a>
        </li> -->
       
      
      </ul>
      <!-- <li
        class="nav-item d-flex align-items-center"
        style="border-bottom: 1px solid #ccc; padding-bottom: 8px"
      >
        <a href="javascript:;" class="nav-link text-body font-weight-bold px-0">
          <i class="fa fa-user me-sm-1"></i>
          <span class="d-sm-inline" @click="closeSession">Cerrar sesión</span>
        </a>
      </li> -->
      <ul class="navbar-nav d-lg-block d-none"></ul>
    </div>
  </div>
</template>
<script src="https://kit.fontawesome.com/42d5adcbca.js" crossorigin="anonymous"></script>
<script>
import { mapActions } from "vuex";
import IconBox3D from '../components/Icons/Box3D'
    import IconCreditCard from '../components/Icons/CreditCard'
    import IconCustomerSupport from '../components/Icons/CustomerSupport'
    import IconOffice from '../components/Icons/Office'
    import IconShop from '../components/Icons/Shop'
    import IconSpaceShip from '../components/Icons/SpaceShip'
    import IconDocument from '../components/Icons/Document'
import Cookies from "js-cookie";

export default {
  components:{
          IconBox3D,
          IconCreditCard,
          IconOffice,
          IconShop,
          IconSpaceShip,
          IconDocument,
          IconCustomerSupport
        },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    getRole() {
      if (this.role == 1) {
        return "Administrador";
      } else if (this.role == 2) {
        return "Asesor";
      } else {
        return "Usuario";
      }
    },
    isAdmin() {
      return this.role == 1 ? true : false;
    },
    isAdvisor() {
      return this.role == 2 ? true : false;
    },
    isUser() {
      console.log(this.role);
      return this.role == undefined ? true : false;
    },
  },
  data() {
    return {
      role: Cookies.get("role"),
      username: Cookies.get("id"),
      name: "",
      activeNotifications: false,
      user:"",
    };
  },
  mounted() {
    this.loadProfile();
  },
  methods: {
    ...mapActions(["logout", "load_User","load_Admin"]),
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    closeSession() {
      console.log("Bye Bye");
      this.logout();
      location.reload();
    },
    loadProfile() {
      if (this.isUser) {
        this.load_User(this.username)
          .then((response) => {
            if (response.code === 200) {
              this.user = response.data;
              this.name = this.user.full_name;
              this.loaded = true;
            }
          })
          .catch((error) => {});
      }
      else{ 
        this.load_Admin(this.username)
          .then((response) => {
            if (response.code === 200) {
              this.user = response.data;
              this.name = this.user.name ;
              this.loaded = true;
            }
          })
          .catch((error) => {});
      }
    },
    goToRoute(route) {
      this.$router.push(route);
      //this.$router.push('/admin/overview')
    },
  },
};
</script>
<style>
@media (min-width: 1200px) {
  .mobilemenu {
    display: none !important;
  }
}
#navigation{
  z-index: 5;
}

.bg-gray-100 {
    background-color: white!important;
}

.home-bg{
  background-color: #f8f9fa !important;
}
</style>
